/**
 * Sorts videos based on providers in order defined in VIDEO_ORDER.
 * Puts unknown providers and videos without providers last.
 *
 * @param videos list of videos
 * @returns {*} sorted list of videos
 */
export const sortVideos = (videos) => {
	// DEALER_UPLOADED should always be first, followed by DCPAIS
	const VIDEO_ORDER = [
		'DEALER_UPLOADED',
		'DCPAIS',
		'DEALER_SPECIALITIES',
		'CARFLIX',
		'SISTER_TECH',
		'UNITY',
		'VIRTUAL_TEST_DRIVE',
		'YOUTUBE'
	];
	return videos.sort((va, vb) => {
		if (
			VIDEO_ORDER.indexOf(va.provider) < 0 &&
			VIDEO_ORDER.indexOf(vb.provider) >= 0
		) {
			return 1;
		}
		if (
			VIDEO_ORDER.indexOf(va.provider) >= 0 &&
			VIDEO_ORDER.indexOf(vb.provider) < 0
		) {
			return -1;
		}
		return (
			VIDEO_ORDER.indexOf(va.provider) - VIDEO_ORDER.indexOf(vb.provider)
		);
	});
};

export const isCarflixVideo = (video) =>
	Boolean(
		video &&
			(video.provider === 'CARFLIX' ||
				(typeof video.uri === 'string' && video.uri.includes('/carflix')))
	);

export const getCarflixMedia = (uri) => {
	if (typeof uri !== 'string' || !/\.xml$/i.test(uri)) {
		return { src: uri, poster: undefined };
	}
	const base = uri.replace(/\.xml$/i, '');
	return { src: `${base}_high.mp4`, poster: `${base}_largethumb.jpg` };
};
